import type { FC } from 'react';

import cat1Image from 'assets/cat1.png';
import cat2Image from 'assets/cat2.png';

import { Placeholder } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const Trls = {
    header: 'BalanceAndBonuses.History.header',
    fullEmptyDescription: 'BalanceAndBonuses.History.emptyPlaceholder.fullEmptyDescription',
    categoryEmptyDescription: 'BalanceAndBonuses.History.emptyPlaceholder.categoryEmptyDescription',
};

export const EmptyHistoryPlaceHolder: FC = () => {
    const trls = useTrls();

    return (
        <Placeholder
            title=""
            titleProps={{
                size: 'medium',
                Element: 'h2',
                alignment: 'center',
                description: trls(Trls.fullEmptyDescription),
            }}
        >
            <Placeholder.Image title="" src={cat2Image} width={110} height={146} />
        </Placeholder>
    );
};

export const EmptyHistoryCategoryPlaceHolder: FC = () => {
    const trls = useTrls();

    return (
        <Placeholder
            title=""
            titleProps={{
                size: 'medium',
                Element: 'h2',
                alignment: 'center',
                description: trls(Trls.categoryEmptyDescription),
            }}
        >
            <Placeholder.Image title="" src={cat1Image} width={198} height={146} />
        </Placeholder>
    );
};
